(() => {
  'use strict';
  const dialog = document.querySelector('[data-launch-dialog]');
  if (!dialog || !dialog.showModal || window.Shopify?.designMode) return;
  const key = 'bae-carbon-popup-v2';
  const started = performance.now();
  let returnFocus;
  const visible = element => element && !element.hidden && element.getClientRects().length > 0;
  const blocked = () => document.visibilityState !== 'visible' ||
    visible(document.querySelector('#shopify-pc__banner')) ||
    visible(document.querySelector('#bae-cookie-panel')) ||
    visible(document.querySelector('.bae-drawer[data-open]')) ||
    document.querySelector('dialog[open]');
  let seen = false;
  try { seen = sessionStorage.getItem(key) === 'seen'; } catch {}
  const open = () => {
    if (dialog.open || blocked()) return false;
    returnFocus = document.activeElement;
    dialog.showModal();
    dialog.querySelector('#bae-launch-dialog-title')?.focus({preventScroll:true});
    seen = true;
    window.removeEventListener('scroll',check);
    try { sessionStorage.setItem(key,'seen'); } catch {}
    return true;
  };
  const check = () => {
    const distance = Math.max(1,document.documentElement.scrollHeight - innerHeight);
    if (!seen && performance.now() - started >= 20000 && scrollY / distance >= .3) open();
  };
  if (!seen) window.addEventListener('scroll',check,{passive:true});
  document.querySelectorAll('[data-launch-open]').forEach(button => button.addEventListener('click',open));
  dialog.querySelectorAll('[data-launch-close]').forEach(button => button.addEventListener('click',() => dialog.close()));
  dialog.addEventListener('click',event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close',() => { if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true}); });
})();

